import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';

import { loadPosts } from 'redux/Posts/actions';
import { clearPosts, searchPosts } from 'redux/PostsSearch/actions';
import { loadPostTags } from 'redux/PostTags/actions';
import { ssrHandler } from 'utils';

import NewsTemplate from './NewsTemplate';

function parseTags({ tags }) {
  let searchTags = [];

  if (!!tags) {
    searchTags = tags
      .split(',')
      .map(num => parseInt(num, 10))
      .filter(num => !isNaN(num));
  }

  return searchTags;
}

function isListView({ list }) {
  return typeof list === 'object';
}

class News extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      listView: isListView(this.props.location.query),
      tags: parseTags(this.props.location.query),
      tagsOpened: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const { isMobile, location } = this.props;

    if (nextProps.isMobile !== isMobile && this.state.tagsOpened) {
      if (nextProps.isMobile) {
        document.documentElement.classList.add('overflow');
      } else {
        document.documentElement.classList.remove('overflow');
      }
    }

    const { query } = nextProps.location;

    if (query.list !== location.query.list
        || query.tags !== location.query.tags) {
      const tags = parseTags(query);
      const { category } = nextProps;

      this.props.clearPosts();
      this.props.searchPosts({ category, tags, page: 1 });

      this.setState({ listView: isListView(query) });
    }
  }

  onListViewClick = () => {
    const query = {
      ...this.props.location.query,
      list: null
    };

    browserHistory.push({
      pathname: this.props.location.pathname,
      query
    });
  };

  onTagsToggle = () => {
    const { tagsOpened } = this.state;
    this.setState({ tagsOpened: !tagsOpened });

    if (tagsOpened) {
      document.documentElement.classList.remove('overlay');
      document.documentElement.classList.remove('overflow');
    } else {
      document.documentElement.classList.add('overlay');

      if (this.props.isMobile) {
        document.documentElement.classList.add('overflow');
      }
    }
  };

  onTagClick = (tagId) => {
    const tags = this.state.tags.slice(0);
    const index = tags.indexOf(tagId);

    if (index !== -1) {
      tags.splice(index, 1);
    } else {
      tags.push(tagId);
    }

    this.setState({ tags, page: 1 });
  };

  onSearchClick = () => {
    this.onTagsToggle();

    const query = {
      list: null
    };

    if (this.state.tags.length) {
      query.tags = this.state.tags.join(',');
    }

    browserHistory.push({
      pathname: this.props.location.pathname,
      query
    });
  };

  onResetClick = () => {
    this.setState({ tags: [], page: 1 });

    browserHistory.push({
      pathname: this.props.location.pathname,
      query: {
        list: null
      }
    });
  };

  onLoadMore = () => {
    const tags = parseTags(this.props.location.query);
    const page = this.state.page + 1;
    const { category } = this.props;

    this.setState({ page });
    this.props.searchPosts({ category, tags, page });
  };

  getPostTags = () => {
    const selectedTags = this.state.tags.slice(0);
    const tags = this.props.tags.results.slice(0);

    for (const item of tags) {
      item.selected = selectedTags.indexOf(item.id) !== -1;
    }

    return tags;
  };

  render() {
    return (
      <NewsTemplate
        pathname={this.props.location.pathname}
        tags={this.getPostTags()}
        tagsOpened={this.state.tagsOpened}
        posts={this.props.posts}
        postsSearch={this.props.postsSearch}
        listView={this.state.listView}
        onTagClick={this.onTagClick}
        onListViewClick={this.onListViewClick}
        onSearchClick={this.onSearchClick}
        onResetClick={this.onResetClick}
        onTagsToggle={this.onTagsToggle}
        onLoadMore={this.onLoadMore}
      />
    );
  }
}

News.propTypes = {
  posts: PropTypes.shape({
    primaryPost: PropTypes.object,
    secondaryPost: PropTypes.object,
    results: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
    fetchingErrors: PropTypes.object
  }),
  tags: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
    fetchingErrors: PropTypes.object
  }),
  isMobile: PropTypes.bool,
  subnavigationOpen: PropTypes.func
};

const mapStateToProps = (state, props) => ({
  isMobile: state.app.layout === 'mobile',
  posts: state.posts,
  postsSearch: state.postsSearch,
  tags: state.postTags,
  category: categories[props.location.pathname]
});

const mapDispatchToProps = {
  loadPosts,
  clearPosts,
  searchPosts
};

function loadPostsData(store, nextState, replace, callback) {
  const listView = isListView(nextState.location.query);
  const searchTags = parseTags(nextState.location.query);
  const category = categories[nextState.location.pathname];

  const actions = [
    loadPostTags(),
    loadPosts(category)
  ];

  if (!!searchTags.length || listView) {
    actions.push(searchPosts({ tags: searchTags, category }));
  }

  ssrHandler(store.dispatch, actions, callback);
}

function clearPostsData(store) {
  store.dispatch(clearPosts());
}

const categories = {
  '/analyze/actually/': 'analyze',
  '/we/news/': 'news'
};

const createRoute = (store, pathname) => ({
  path: pathname,
  component: connect(mapStateToProps, mapDispatchToProps)(News),
  onEnter: loadPostsData.bind(null, store),
  onLeave: clearPostsData.bind(null, store)
});

export default (store) => Object.keys(categories).map(createRoute.bind(null, store));



// WEBPACK FOOTER //
// ./src/components/News/index.js